import { render, staticRenderFns } from "./Form.input.text.vue?vue&type=template&id=08241f54"
import script from "./Form.input.text.vue?vue&type=script&lang=js"
export * from "./Form.input.text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports